import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "semantic-ui-react";

import { XentryStatusModal } from "modules/AppointmentDetails/components/CarDetails/components/XentryStatus/components";
import { useXentryJobsQuery } from "modules/AppointmentDetails/components/CarDetails/components/XentryStatus/hooks";

import type { Brand } from "models";

const XENTRY_JOB_ID_PLACEHOLDER = "{{.XentryJobID}}";

type XentryStatusProps = {
  vinNr: string;
  carBrands: Brand[];
  appointmentId?: number;
  isXentryEnabled?: boolean;
  subOutletId?: string;
};

const isXentryVehicle = (carBrands: Brand[], vinNr: string) =>
  carBrands.some(
    brand =>
      brand.is_active &&
      brand.vin_prefix &&
      vinNr.startsWith(brand.vin_prefix) &&
      (brand.servicebox_wo.includes(XENTRY_JOB_ID_PLACEHOLDER) || brand.servicebox_wo_2.includes(XENTRY_JOB_ID_PLACEHOLDER))
  );

const XentryStatusContent = ({ appointmentId }: { appointmentId?: number }) => {
  const { t } = useTranslation();

  const [isModalOpen, setIsModalOpen] = useState(false);
  const { xentryJob, isXentryJobFetching, fetchXentryJob } = useXentryJobsQuery({ appointmentId });

  const handleToggleModal = () => {
    if (!isModalOpen) fetchXentryJob();
    setIsModalOpen(!isModalOpen);
  };

  return (
    <>
      <Button className="-appointment-status" size="small" loading={isXentryJobFetching && !isModalOpen} onClick={handleToggleModal}>
        XENTRY {t("v8_status", "Status").toUpperCase()}
      </Button>
      <XentryStatusModal data={xentryJob} isOpen={isModalOpen} loading={isXentryJobFetching} onClose={handleToggleModal} onRefresh={fetchXentryJob} />
    </>
  );
};

export const XentryStatus = ({ appointmentId, isXentryEnabled, subOutletId, carBrands, vinNr }: XentryStatusProps) => {
  if (!isXentryEnabled || !subOutletId || !isXentryVehicle(carBrands, vinNr)) return null;

  return <XentryStatusContent appointmentId={appointmentId} />;
};
